import { createScheduledOrder } from '../constants';

const scheduledOrder = (state, action) => {
    if (state === undefined) {
        return {
            data: {},
            loading: false,
            error: null,
            success: false,
        };
    }

    switch (action.type) {
        case createScheduledOrder.FETCH_CREATE_SCHEDULED_ORDER_REQUEST:
            return {
                data: {},
                loading: true,
                error: null,
                success: false,
            };

        case createScheduledOrder.FETCH_CREATE_SCHEDULED_ORDER_SUCCESS:
            return {
                data: action.payload,
                loading: false,
                error: null,
                success: true,
            };

        case createScheduledOrder.FETCH_CREATE_SCHEDULED_ORDER_FAILURE:
            return {
                data: {},
                loading: false,
                error: action.payload,
                success: false,
            };

        default:
            return state;
    }
};

export default scheduledOrder;
